// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"572":"afbf0482","971":"8c4f0131"}[chunkId] + ".js";
};